const ALLOWED_MONERIS_SCRIPT_URLS = new Set([
  'https://gatewayt.moneris.com/chkt/js/chkt_v1.00.js',
  'https://gateway.moneris.com/chkt/js/chkt_v1.00.js',
]);
const scriptPromises = new Map();

export function safeMonerisScriptUrl(value) {
  let url;
  try {
    url = new URL(String(value || ''), window.location.origin);
  } catch {
    throw new Error('The payment provider returned an invalid checkout URL.');
  }
  if (!ALLOWED_MONERIS_SCRIPT_URLS.has(url.href)) {
    throw new Error('The payment provider returned an untrusted checkout URL.');
  }
  return url.href;
}

export function loadMonerisCheckoutScript(value) {
  const url = safeMonerisScriptUrl(value);
  if (typeof window.monerisCheckout === 'function') return Promise.resolve(window.monerisCheckout);
  if (scriptPromises.has(url)) return scriptPromises.get(url);
  const promise = new Promise((resolve, reject) => {
    const existing = Array.from(document.querySelectorAll('script[data-mcc-moneris-src]'))
      .find((item) => item.dataset.mccMonerisSrc === url);
    const script = existing || document.createElement('script');
    const finish = () => {
      if (typeof window.monerisCheckout === 'function') resolve(window.monerisCheckout);
      else reject(new Error('Secure checkout did not become available.'));
    };
    script.addEventListener('load', finish, { once: true });
    script.addEventListener('error', () => reject(new Error('Secure checkout could not be loaded.')), { once: true });
    if (!existing) {
      script.src = url;
      script.async = true;
      script.dataset.mccMonerisSrc = url;
      document.head.appendChild(script);
    }
  }).catch((error) => {
    scriptPromises.delete(url);
    throw error;
  });
  scriptPromises.set(url, promise);
  return promise;
}

export function callbackTicket(payload, fallback = '') {
  if (!payload) return fallback;
  if (typeof payload === 'object') {
    return String(payload.ticket || payload.checkout_ticket || payload.ticket_id || fallback || '');
  }
  const text = String(payload);
  try {
    const parsed = JSON.parse(text);
    return callbackTicket(parsed, fallback);
  } catch {
    return text.trim() || fallback;
  }
}

export function createMonerisCheckout({ environment, containerId, callbacks }) {
  if (typeof window.monerisCheckout !== 'function') throw new Error('Secure checkout is unavailable.');
  const checkout = new window.monerisCheckout();
  checkout.setMode(String(environment || 'qa').toLowerCase() === 'prod' ? 'prod' : 'qa');
  checkout.setCheckoutDiv(containerId);
  ['page_loaded', 'cancel_transaction', 'error_event', 'payment_receipt', 'payment_complete'].forEach((name) => {
    checkout.setCallback(name, callbacks[name] || (() => {}));
  });
  return checkout;
}
